import script from "./SummaryHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SummaryHeader.vue?vue&type=script&setup=true&lang=ts"

import "./SummaryHeader.vue?vue&type=style&index=0&id=37dcd350&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37dcd350"]])

export default __exports__